import isInIframe from '@anm/helpers/is/isInIframe';
import { useCallback, useEffect, useRef } from 'react';
import { DEFAULT_VIEW_TYPE } from './../../../../constants/videoLandings';

var useLayoutHeight = function useLayoutHeight(_ref) {
  var page = _ref.page,
      _ref$viewType = _ref.viewType,
      viewType = _ref$viewType === void 0 ? DEFAULT_VIEW_TYPE : _ref$viewType,
      _ref$isCustomization = _ref.isCustomization,
      isCustomization = _ref$isCustomization === void 0 ? false : _ref$isCustomization;
  var layoutRef = useRef(null);
  var sendMessage = useCallback(function (minHeight) {
    return window.parent.postMessage({
      minHeight: minHeight
    }, '*');
  }, [layoutRef.current]);
  useEffect(function () {
    if (!layoutRef.current || !isInIframe() || !isCustomization) return;
    var timeId = setTimeout(function () {
      var _layoutRef$current;

      var layoutHeight = (_layoutRef$current = layoutRef.current) === null || _layoutRef$current === void 0 ? void 0 : _layoutRef$current.scrollHeight;
      layoutHeight && sendMessage(layoutHeight);
    }, 0);
    return function () {
      return clearTimeout(timeId);
    };
  }, [page, viewType, layoutRef.current, isCustomization]);
  return layoutRef;
};

export default useLayoutHeight;